import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button } from "antd";

import AudioJoinerWork from "./children/AudioJoinerWork";
import "@/assets/audioJoiner.less";

class AudioJoiner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  render() {
    const { t } = this.props;
    return (
      <div className="AudioJoiner">
        {!this.state.workPlaceVisible ? (
          <div className="audio-work-hd">
            <h1 className="container">{t("HitPaw Online Audio Joiner")}</h1>
            <p className="container">{t("Merge multiple audio tracks into one.")}</p>
            <Button size="large" onClick={() => this.setState({ workPlaceVisible: true })}>
              {t("common:Get Started")}
            </Button>
          </div>
        ) : (
          <AudioJoinerWork />
        )}
      </div>
    );
  }
}

export default connect()(withTranslation(["audioJoiner", "common"])(AudioJoiner));
